import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ColumnMode, TableColumn } from '@swimlane/ngx-datatable';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Md5 } from 'ts-md5';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { EmployeeUsersService } from 'src/app/services/employee-users/employee-users.service';
import { RingcentralService } from 'src/app/services/ringcentral/ringcentral.service';

@Component({
	selector: 'app-employee-users',
	templateUrl: './employee-users.component.html',
	styleUrls: ['./employee-users.component.scss'],
})
export class EmployeeUsersComponent implements OnInit {

	msgError: string = '';
	users: any = null;
	loading = false;
	filterClient: string = '';
	SearchFilters = [];
	//table
	employeeUsers: any = [];
	columnMode = ColumnMode;
	showPass: any;
	columns: TableColumn[];
	reorderable: boolean;
	editUserMode: boolean = false;

	createEmployeeUserForm: FormGroup;
	sendPasswordForm: FormGroup;

	constructor(private modalService: NgbModal, private employeeUsersService: EmployeeUsersService, public ringcentralSrv: RingcentralService,  private userSrv: UserService, private router: Router, public authenticationService: AuthenticationService, public utils: UtilsService, private fb: FormBuilder) {
		this.createEmployeeUserForm = this.fb.group({
			name: ['', Validators.required],
			lastname: ['', Validators.required],
			ringcentral_ext: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			isAdmin: [false],
			isCaller: [true],
			isDbReset: [false],
			id: [null]
		});

		this.sendPasswordForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]]
		});
	}

	//field search
	@ViewChild('Login') login: ElementRef;
	@ViewChild('First') first: ElementRef;
	@ViewChild('last') last: ElementRef;

	ngOnInit() {
		this.getEmployeeUsers(1);
	}
	cleanFiltersSearch() {
		this.login.nativeElement.value = '';
		this.first.nativeElement.value = '';
		this.last.nativeElement.value = '';

		if (this.filterClient == 'Active') {
			this.getEmployeeUsers(1);
		} else {
			this.getEmployeeUsers(0);
		}
	}

	getEmployeeUsers(status: number) {
		this.loading = true;
		this.employeeUsers = null;

		this.userSrv.getEmployeeUsersStatus(status).subscribe((data: any) => {
			this.employeeUsers = data.body;
			this.loading = false;
			this.SearchFilters = this.employeeUsers;
			if (status === 1) {
				this.filterClient = 'Active';
			} else {
				this.filterClient = 'Inactive';
			}
		});
	}

	deactivateUserConfirm(user: any) {
		Swal.fire({
			title: 'Deactivate ' + user.name + ' ?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.employeeUsersService.deactiveUser(user.id).subscribe((data: any) => {
					Swal.fire("User Deactivated");
					this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
				});
			}
		});
	}
	activateUserConfirm(user: any) {
		Swal.fire({
			title: 'Activate ' + user.name + ' ?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.employeeUsersService.activateUser(user.id).subscribe((data: any) => {
					Swal.fire("User Activated");
					this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
				});
			}
		});
	}
	deactivateUserAdminConfirm(user: any) {
		Swal.fire({
			title: 'Deactivate Admin Role for ' + user.name + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.employeeUsersService.deactivateUserAdmin(user.id).subscribe((data: any) => {
					Swal.fire("Admin Role Deactivated");
					this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
				});
			}
		});
	}
	activateUserAdminConfirm(user: any) {
		Swal.fire({
			title: 'Activate Admin Role for ' + user.name + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.employeeUsersService.activateUserAdmin(user.id).subscribe((data: any) => {
					Swal.fire("Admin Role Activated");
					this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
				});
			}
		});
	}
	activateDbResetConfirm(user: any) {
		Swal.fire({
			title: 'Activate DB Reset for ' + user.name + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.employeeUsersService.activateUserDBreset(user.id).subscribe((data: any) => {
					Swal.fire("DB Reset Activated");
					this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
				});
			}
		});
	}
	deactivateDbResetConfirm(user: any) {
		Swal.fire({
			title: 'Deactivate DB Reset for ' + user.name + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.employeeUsersService.deactiveUserDBreset(user.id).subscribe((data: any) => {
					Swal.fire("DB Reset Deactivated");
					this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
				});
			}
		});
	}
	activateCaller(user: any) {
		this.employeeUsersService.activateUserCaller(user.id).subscribe((data: any) => {
			if(data.success){
				Swal.fire("Caller activated");
			} else {
				Swal.fire("Error activating Caller");
			}
			this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
		});
	}
	deactivateCaller(user: any) {
		this.employeeUsersService.deactivateUserCaller(user.id).subscribe((data: any) => {
			if(data.success){
				Swal.fire("Caller deactivated");
			} else {
				Swal.fire("Error deactivating Caller");
			}
			this.filterClient === 'Active' ? this.getEmployeeUsers(1) : this.getEmployeeUsers(0);
		});
	}
	getCellClassLogin({ row, column, value }: { row: any; column: any; value: any }): any {
		return {
			' back-cell-gray content-point ': row['isActive'] == 0,
			' back-cell-blue content-point ': row['isActive'] == 1,
		};
	}
	editUser(user: any) {
		this.router.navigate(['/user-edit'], { queryParams: { id: user.id } });
	}
	updateFilter(event: any, opcion: any) {
		const val = event.target.value.toLowerCase();
		let answer_filter: any[] = [];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.employeeUsers;
		} else {
			searchWithFilters = this.SearchFilters;
		}

		switch (opcion) {
			case 1: //login
				answer_filter = searchWithFilters.filter(function (d) {
					return d.login.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 2: // Name
				answer_filter = searchWithFilters.filter(function (d) {
					return d.name.toLowerCase().indexOf(val) !== -1 || !val;
				});
				break;
			default:
				break;
		}

		this.employeeUsers = answer_filter;
	}

	getUserPass(fullname: any) {
		const last = fullname.split(' ').pop();
		return this.utils.getUserPass(last);
	}

	openCreateUserModal(content) {
		this.editUserMode = false;
		this.createEmployeeUserForm.reset();
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info(result);
			},
			(reason) => {
				console.info(reason);
			}
		);
	}

	openEditUserModal(content, user) {
		this.editUserMode = true;
		this.createEmployeeUserForm.reset();
		const nameParts = user.name.split(' ');
		this.createEmployeeUserForm.patchValue({
			name: nameParts[0],
			lastname: nameParts[1],
			ringcentral_ext: user.ringcentral_ext,
			email: user.email1,
			isAdmin: user.isAdmin,
			isCaller: user.isCaller,
			isDbReset: user.isDbReset,
			id: user.id,
		});
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info(result);
			},
			(reason) => {
				console.info(reason);
			}
		);
	}

	validateAndSubmit() {
		this.createEmployeeUserForm.markAllAsTouched();
		if (this.createEmployeeUserForm.valid) {
			const formData = this.createEmployeeUserForm.value; // Obtiene los valores del formulario
			const md5 = new Md5();
			formData.pass = md5.appendStr(this.utils.getUserPass(formData.lastname)).end();

			this.userSrv.createEmployeeUser(formData).subscribe(
				(data) => {
					this.createEmployeeUserForm.reset();
					this.modalService.dismissAll();
					this.getEmployeeUsers(1);
					Swal.fire({
						title: 'Success',
						icon: 'success',
						text: 'Employee user created successfully',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					});
				},
				(error) => {
					console.error(error);
					Swal.fire({
						title: 'Error',
						icon: 'error',
						text: 'Something went wrong',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					});
				}
			);
		} else {
			console.error('Form is invalid');
		}
	}

	getRingCentralExtension(row) {
		const payload = { email: row.email1 }
		this.ringcentralSrv.getUserExtension(payload).subscribe((data: any)=>{
			this.getEmployeeUsers(1);
		});
	}

	updateEmployeeUser() {
		this.createEmployeeUserForm.markAllAsTouched();

		if (this.createEmployeeUserForm.valid) {
			const formData = this.createEmployeeUserForm.value; // Obtiene los valores del formulario

			this.userSrv.updateEmployeeUser(formData).subscribe(
				(data) => {
					this.createEmployeeUserForm.reset();
					this.modalService.dismissAll();
					this.getEmployeeUsers(1);
					Swal.fire({
						title: 'Success',
						icon: 'success',
						text: 'Employee user updated successfully',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					});
				},
				(error) => {
					console.error(error);
					Swal.fire({
						title: 'Error',
						icon: 'error',
						text: 'Something went wrong',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					});
				}
			);
		} else {
			console.error('Form is invalid');
		}
	}

	openSendPasswordModal(content) {
		this.sendPasswordForm.reset();
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info(result);
			},
			(reason) => {
				console.info(reason);
			}
		);
	}

	sendPasswordEmployeeCreation(email, name) {
			Swal.fire({
				title: 'Enviando...',
				text: 'Sending password creation email',
				confirmButtonText: 'Ok',
				didOpen: () => {
					Swal.showLoading();
					this.userSrv.send_password_employee_creation(email, name).subscribe(
						(data: any) => {
							Swal.close();
							this.modalService.dismissAll();
							Swal.fire({
								title: 'Success',
								icon: 'success',
								text: 'Email sent successfully',
								showCancelButton: false,
								confirmButtonText: 'Ok',
							});
						},
						(error) => {
							Swal.close();
							Swal.fire({
								title: 'Error',
								icon: 'error',
								text: 'Failed to send email',
								showCancelButton: false,
								confirmButtonText: 'Ok',
							});
						}
					);
				}
			});

	}
}
